// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

import Vue from 'vue'
import Vuetify from 'vuetify'
import App from './App'
import router from './router'
import VueFire from 'vuefire'
import Vuex from 'vuex'
import VueWorker from 'vue-worker'
import {store} from './store'
import {firebaseApp} from './firebase/firebase'
import 'vuetify/dist/vuetify.css'

Vue.use(Vuex)

Vue.use(Vuetify, {
  theme:
  {
    'primary': '#B0BEC5',
    'secondary': '#004D40',
    'accent': '#DD2C00',
    'error': '#FF6D00',
    'warning': '#F4511E',
    'info': '#4DB6AC',
    'success': '#00897B'
  }
})
Vue.use(VueFire)
Vue.use(VueWorker)
Vue.config.productionTip = false
/* eslint-disable no-new */
new Vue({
  el: '#app',
  template: '<App/>',
  router,
  store,
  render: h => h(App),
  methods: {
    ...Vuex.mapActions('user', {
      updateAuthData: 'updateAuthData'
    })
  },
  created () {
    firebaseApp
    firebaseApp.auth().onAuthStateChanged((user) => {
      if (user) {
        this.updateAuthData(user)
        // store.dispatch('updateAuthData', user)
      } else {
        this.updateAuthData(null)
        // store.dispatch('updateAuthData', null)
      }
    })
  }
})



// WEBPACK FOOTER //
// ./src/main.js